import { call, put, takeEvery } from 'redux-saga/effects'
import * as orderActions from '../ducks/orderDucks'
import * as orderApi from '../../api/orderApi'

interface FetchOrderCurrencyListSaga {
  type: string
  payload: string
}
interface FetchOrderPurchasesRealityListSaga {
  type: string
  payload: string
}
interface FetchOrderPurchasesListSaga {
  type: string
  payload: string
}

interface FetchOrderDetailSaga {
  type: string
  payload: string
}
interface FetchRequestListSaga {
  type: string
  payload: string
}
interface FetchBillOfLadingCodeListSaga {
  type: string
  payload: string
}


interface FetchSaga {
  type: string
  payload: string
}


function* fetchListOrderCurrency({ payload: queryString }: FetchOrderCurrencyListSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderCurrency> = yield call(orderApi.getListOrderCurrency, queryString)
    yield put(orderActions.getListOrderCurrencySuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderCurrencyFail(error))
  }
}

function* fetchListOrderPurchasesReality({ payload: queryString }: FetchOrderPurchasesRealityListSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderPurchasesReality> = yield call(orderApi.getListOrderPurchasesReality, queryString)
    yield put(orderActions.getListOrderPurchasesRealitySuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderPurchasesRealityFail(error))
  }
}

function* fetchListOrderPurchases({ payload: queryString }: FetchOrderPurchasesListSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderPurchases> = yield call(orderApi.getListOrderPurchases, queryString)
    yield put(orderActions.getListOrderPurchasesSuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderPurchasesFail(error))
  }
}

function* fetchDetailOrder({ payload: id }: FetchOrderDetailSaga) {
  try {
    const res: ReturnType<typeof orderApi.getDetailOrder> = yield call(orderApi.getDetailOrder, id)
    yield put(orderActions.getDetailOrderSuccess(res))
  } catch (error) {
    yield put(orderActions.getDetailOrderFail(error))
  }
}

function* fetchListRequest({ payload: queryString }: FetchRequestListSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListRequest> = yield call(orderApi.getListRequest, queryString)
    yield put(orderActions.getListRequestSuccess(res))
  } catch (error) {
    yield put(orderActions.getListRequestFail(error))
  }
}

function* fetchListHistoryOrder({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListHistoryOrder> = yield call(orderApi.getListHistoryOrder, queryString)
    yield put(orderActions.getListHistoryOrderSuccess(res))
  } catch (error) {
    yield put(orderActions.getListHistoryOrderFail(error))
  }
}



function* fetchListBillOfLadingCode({ payload: queryString }: FetchBillOfLadingCodeListSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListBillOfLadingCode> = yield call(orderApi.getListBillOfLadingCode, queryString)
    yield put(orderActions.getListBillOfLadingCodeSuccess(res))
  } catch (error) {
    yield put(orderActions.getListBillOfLadingCodeFail(error))
  }
}


export default function* watchOrder() {
  yield takeEvery(orderActions.getListOrderCurrency.toString(), fetchListOrderCurrency)
  yield takeEvery(orderActions.getListOrderPurchasesReality.toString(), fetchListOrderPurchasesReality)
  yield takeEvery(orderActions.getListOrderPurchases.toString(), fetchListOrderPurchases)

  yield takeEvery(orderActions.getDetailOrder.toString(), fetchDetailOrder)
  yield takeEvery(orderActions.getListRequest.toString(), fetchListRequest)

  yield takeEvery(orderActions.getListHistoryOrder.toString(), fetchListHistoryOrder)

  yield takeEvery(orderActions.getListBillOfLadingCode.toString(), fetchListBillOfLadingCode)



}
